import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setFavList } from '@Redux/search/actions';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import { RootState } from '@Redux/search/store';
import { getIsFavorite } from '@utils/favorite';
import { member } from '@utils/domainByEnv';
import Pc from './subComponent/Pc';
import M from './subComponent/M';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './styles.module.scss';

const ResultCards = () => {
    const { SwitchListBy, favList } = useSelector((state: RootState) => state.search.reducer);
    const dispatch = useDispatch();
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });
    const [isLogin, setIsLogin] = useState<boolean>(false);
    // const [favList, setFavList] = useState<any>();

    // 確認是否登入
    useEffect(() => {
        (async function () {
            try {
                const memberRes = await fetch(`${member}/account/checkmemberlogin`, {
                    method: 'post',
                    // 會帶 cookie 過去
                    credentials: 'include',
                });
                const memberData = await memberRes.json();
                setIsLogin(memberData.IsLogin);
            } catch (ex) {
                console.log('Fetch Member Data Error', ex);
            }
        })();
    }, []);

    // 一進頁面時，如果有 Login，則判斷有沒有加入收藏 參數0 撈出所有產品館別
    useEffect(() => {
        if (isLogin) {
            (async () => {
                const favList = await getIsFavorite(0);
                dispatch(setFavList(favList));
            })();
        }
    }, [isLogin]);

    const isCards: boolean = SwitchListBy === 'List';
    return (
        <div className={cN('ResultCards', styles.ResultCards, { [`${styles.show}`]: isCards })}>
            {isMobile ? <M isLogin={isLogin} /> : <Pc isLogin={isLogin} />}
        </div>
    );
};

export default ResultCards;
